import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Box,
} from '@mui/material';
import { useTranslation } from 'react-i18next';

interface EmailVerificationDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (email: string) => void;
}

const EmailVerificationDialog: React.FC<EmailVerificationDialogProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [email, setEmail] = useState('');
  const { t } = useTranslation();

  const handleSubmit = (): void => {
    onSubmit(email);
    setEmail('');
  };

  return (
    <Dialog
      open={open}
      maxWidth="sm"
      fullWidth
      disableEscapeKeyDown
      onClose={(event, reason) => {
        if (reason === 'backdropClick') {
          return;
        }
        onClose();
      }}
    >
      <DialogTitle>
        {t('EMAILVERIFICATION.title', "To ensure it's you, please enter email")}
      </DialogTitle>
      <DialogContent>
        <Box sx={{ mt: 2 }}>
          <TextField
            autoFocus
            margin="dense"
            label={t('EMAILVERIFICATION.emailLabel', 'Email')}
            type="email"
            fullWidth
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </Box>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', p: 2 }}>
        <Button
          onClick={handleSubmit}
          variant="contained"
          disabled={!email}
          sx={{ maxWidth: '200px', width: '100%' }}
        >
          {t('COMMON.submit', 'Submit')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EmailVerificationDialog;
